import { Img } from "ui-kit/components-branded/index"
import { MyAuthorizationLink, MySessionsLink } from "app/AppRouter/links"
import { useClientContext } from "modules/ClientAuthorization/common/ClientContext"

const buttonClass = "try-again__primary-button b-button transition-ease"

export function CanceledPage() {
    const [{ isVerified }] = useClientContext()

    return (
        <div className="redesign-container">
            <div className="pay-container mt-3">
                <div className="try-again__container">
                    <section className="try-again">
                        <div>
                            <div className="try-again__headline">Сессия отменена</div>
                        </div>
                        <Img
                            className="try-again__card-illustration"
                            src="time-ill.svg"
                            width={296}
                            height={168}
                        />
                        {isVerified ? (
                            <MySessionsLink className={buttonClass}>
                                Перейти к&nbsp;сессиям
                            </MySessionsLink>
                        ) : (
                            <MyAuthorizationLink className={buttonClass}>
                                Войти в&nbsp;Мой Alter
                            </MyAuthorizationLink>
                        )}
                    </section>
                </div>
            </div>
        </div>
    )
}
